import React, { useState } from "react"
import { Button, CircularProgress } from "@material-ui/core"
import CheckIcon from "@material-ui/icons/Check"
import CloseIcon from "@material-ui/icons/Close"
import withStyles from "@material-ui/core/styles/withStyles"
import styles from "./styles"
import clsx from "clsx"
const LoaderButton = props => {
  const {
    classes,
    children,
    classoverrides,
    working,
    bigButton,
    style,
    variant = "contained",
    buttonStyle,
    ...rest
  } = props
  const [showSuccess] = useState(false)
  const [showError] = useState(false)
  return (
    <div
      className={clsx(classes.wrapper, classoverrides.wrapper, {
        [classes.wrapperFullWidth]: props.fullWidth
      })}
      style={style}
    >
      <Button
        disabled={working}
        {...rest}
        className={classes.button}
        classes={classoverrides.button}
        style={buttonStyle}
        variant={variant}
      >
        <div
          className={clsx(classes.promiseSuccessIcon, {
            [classes.showPromiseIcon]: showSuccess
          })}
        >
          <CheckIcon className={clsx(classes.checkIcon, classes.promiseIcon)} />
        </div>
        <div
          className={clsx(classes.promiseErrorIcon, {
            [classes.showPromiseIcon]: showError
          })}
        >
          <CloseIcon className={clsx(classes.closeIcon, classes.promiseIcon)} />
        </div>
        {children}
      </Button>
      {working && (
        <CircularProgress
          color={
            !props.hasOwnProperty("variant") || props.variant === "text"
              ? "primary"
              : "inherit"
          }
          size={24}
          className={
            bigButton ? classes.bigButtonProgress : classes.buttonProgress
          }
          classes={classoverrides.circularProgress}
          disableShrink
        />
      )}
    </div>
  )
}
LoaderButton.defaultProps = {
  classoverrides: {
    wrapper: {}
  }
}
export default withStyles(styles, { withTheme: true, name: "CAT" })(
  LoaderButton
)



// WEBPACK FOOTER //
// ./src/components/LoaderButton/index.js